import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Box } from '@fiverr-private/theme';
import { getStylingProps, getChildren, shouldRenderFormFooter } from '../FormControl/helpers';
import { ControlProps } from '../types';
import { FormContext } from '../FormContext';

const Control = ({
  maxLength,
  isSuccess,
  isError,
  children,
  dataTrackTag = 'control',
  dataTrackValue,
}: ControlProps) => {
  const { FormHeader, FormElement, FormHelperText, FormCounter } = getChildren(children);
  const { wrapper, footer } = getStylingProps({ isError, isSuccess });

  return (
    <FormContext.Provider
      value={{
        maxLength,
        isError,
        isSuccess,
      }}
    >
      <Stack dataTrackTag={dataTrackTag} dataTrackValue={dataTrackValue} {...wrapper}>
        {FormHeader}
        {FormElement}
        {shouldRenderFormFooter({
          FormHelperText,
          FormCounter,
        }) && (
          <Box {...footer}>
            {FormHelperText}
            {FormCounter}
          </Box>
        )}
      </Stack>
    </FormContext.Provider>
  );
};

Control.displayName = 'Control';
export default Control;
